import { z } from "zod"

import { MAX_SURCHARGES_PER_ROW } from "@/screens/Pricing/components/tables/constants"

export const surchargeItemSchema = z.object({
  price: z.number().nullable(),
  description: z.string(),
})

export const surchargeFormSchema = z.object({
  surcharges: z.array(surchargeItemSchema).min(1).max(MAX_SURCHARGES_PER_ROW),
})

export type SurchargeItem = z.infer<typeof surchargeItemSchema>
export type SurchargeFormValues = z.infer<typeof surchargeFormSchema>
